module.exports = __webpack_public_path__ + "my.png?e626ea7741ebf82d348a13c61df96d2f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my.png
// module id = 273
// module chunks = 0 1